import { ref } from 'vue';

// Global reactive state for plan selection modal
const showPlanSelectionModal = ref(false);
export function usePlanSelection() {
  const openPlanSelection = () => {
    showPlanSelectionModal.value = true;
  };
  const closePlanSelection = () => {
    showPlanSelectionModal.value = false;
  };
  return {
    showPlanSelectionModal,
    openPlanSelection,
    closePlanSelection
  };
}